import { faCardsBlank } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { RainbowBox } from '@sorare/core/src/atoms/layout/RainbowBox';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LinkBox } from '@sorare/core/src/atoms/navigation/Box';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const HighlightWrapper = styled(RainbowBox)`
  display: flex;
  gap: var(--intermediate-unit);
  border: 2px solid transparent;
  padding: var(--unit);
  align-items: center;
`;

const TextWrapper = styled(LinkBox)`
  display: inline;
  align-items: center;

  @media ${tabletAndAbove} {
    display: inline-flex;
    gap: var(--unit);
  }
`;

const Description = styled(LabelM)`
  line-height: 1;
`;

const IconWrapper = styled(Horizontal).attrs({ gap: 0, center: true })`
  height: var(--triple-unit);
  width: var(--triple-unit);
  font-size: var(--intermediate-unit);
  color: var(--c-white);
  border-radius: 50%;
`;

type Props = {
  message: ReactNode;
  lightColor: string;
  darkColor: string;
  cta?: ReactNode;
};

export const LeaderboardHighlight = ({
  message,
  lightColor,
  darkColor,
  cta,
}: Props) => {
  return (
    <HighlightWrapper>
      <IconWrapper
        style={{
          background: `linear-gradient(
          27.65deg,
          ${darkColor} 21.95%,
          ${lightColor} 109.77%
        )`,
        }}
      >
        <FontAwesomeIcon icon={faCardsBlank} size="sm" />
      </IconWrapper>
      <TextWrapper>
        <Description>{message}</Description>
        {cta}
      </TextWrapper>
    </HighlightWrapper>
  );
};
